/*
  AMOR: "added to cart" popup.
  Every add-to-cart form on the shop (PDP, product cards, sliders) is captured here, so the theme's
  own cart drawer/notification never runs. After /cart/add.js we load the popup body from the added
  product's page (section am-cart-popup) and let the customer pick matching furniture by size/colour.
  The popup shows what was really added: the number of pieces (quantity box or a whole set), their total
  and, when the cart has a discount (the set discount from 3 pieces of furniture), the price after it (owner, 6.10.2026).
  Set discount (13.10.2026): only furniture counts and gets it. Product type "Akcesoria" (stelaże, półki, szuflady,
  dostawki, oświetlenie) does not, as in the automatic discount (collection "Meble (rabat za zestaw)": type is not
  Akcesoria), snippets/am-perks, am-pdp-delivery, am-config and sections/am-product-bundle.
  The set discount does not combine with promotions (owner, 13.10.2026): furniture with a crossed-out price neither
  counts nor gets it (the discount's collection also requires "price not reduced"). cart.js has no compare-at price,
  so the perks read it from /products/<handle>.js (saleIdsFor below).
  Cart page: "Usuń wszystko" empties the cart after an inline confirmation.
*/
(function () {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  // i18n (snippets/am-i18n, rendered by layout/theme.liquid): AMOR_I18N = strings in the page's language, AMOR_MKT =
  // the market's facts, AMOR_MONEY = amounts in another currency than złoty. The Polish text is the fallback.
  const T = (k, d) => { const v = (window.AMOR_I18N || {})[k]; return typeof v === 'string' && v ? v : d; };
  const F = (s, o) => String(s).replace(/\{(\w+)\}/g, (m, k) => (o[k] != null ? o[k] : m));
  const MKT = window.AMOR_MKT || {};

  // 1 mebel, 2-4 meble, 5+ mebli (another language: its own forms, AMOR_I18N.plural_mebel)
  function mebel(n) {
    const f = (window.AMOR_I18N || {}).plural_mebel;
    if (f && typeof f === 'object' && window.AMOR_PLURAL) return window.AMOR_PLURAL(n, f);
    if (n === 1) return 'mebel';
    const t = n % 10;
    const h = n % 100;
    return t >= 2 && t <= 4 && (h < 12 || h > 14) ? 'meble' : 'mebli';
  }

  // ---- perks: free delivery + set discount (same rules and wording as snippets/am-perks) -----
  // grosze; delivery is free from 1000 zł (AMOR_MKT.free; Czech market: 0, delivery always free, no progress bar)
  const FREE = MKT.free != null ? Number(MKT.free) : 100000;
  // 13.10.2026 (audit CON-06): the shop's own format, as everywhere else ("1.000 zł"), not the browser's pl-PL one,
  // which wrote "1000 zł" under 10 000 and "12 345 zł" above.
  function zl(c) {
    return pln(c);
  }

  // Product type "Akcesoria": does not count for the set discount and does not get it (13.10.2026).
  const isAcc = (t) => String(t || '').trim().toLowerCase() === 'akcesoria';

  // Variant ids in the cart that sit in a promotion (compare-at above price): they neither count nor get the set
  // discount (13.10.2026). One request per product handle, kept for the page; on an error the piece counts as before.
  const saleCache = {};
  function saleIdsFor(cart) {
    const handles = [...new Set((cart.items || []).filter((i) => !isAcc(i.product_type)).map((i) => i.handle).filter(Boolean))];
    return Promise.all(handles.map((h) => {
      if (!saleCache[h]) {
        saleCache[h] = fetch(root + 'products/' + h + '.js', { headers: { Accept: 'application/json' } })
          .then((r) => r.json())
          .then((p) => (p.variants || []).filter((v) => v.compare_at_price > v.price).map((v) => Number(v.id)))
          .catch(() => []);
      }
      return saleCache[h];
    })).then((lists) => new Set([].concat(...lists)));
  }

  function perksHtml(cart, sale) {
    const total = cart.total_price;
    const left = FREE - total;
    const pct = FREE > 0 ? Math.min(100, Math.floor((total * 100) / FREE)) : 100;
    // pieces of furniture that count (qty), of accessories (acc) and of furniture in a promotion (promo)
    let qty = 0;
    let acc = 0;
    let promo = 0;
    (cart.items || []).forEach((i) => {
      if (isAcc(i.product_type)) acc += i.quantity || 0;
      else if (sale && sale.has(Number(i.variant_id))) promo += i.quantity || 0;
      else qty += i.quantity || 0;
    });
    // Since 13.10.2026 the set discount applies to products (furniture lines), so it sits in the lines'
    // allocations; an order-level discount with that title is still recognised.
    const isSet = (t) => /zestaw|sestav/i.test(t || '');
    const applied =
      (cart.cart_level_discount_applications || []).some((d) => isSet(d.title)) ||
      (cart.items || []).some((i) =>
        (i.line_level_discount_allocations || []).some((a) => isSet((a.discount_application || {}).title))
      );
    const ship = MKT.cz
      ? T('cart_ship_cz_html', '<b>Darmowa dostawa do Czech</b> pod wskazany adres.')
      : left > 0
        ? F(T('cart_ship_left_html', 'Brakuje <b>{amount}</b> do darmowej dostawy. Teraz dostawa kosztuje 49 zł.'), { amount: zl(left) })
        : T('cart_ship_free_html', '<b>Masz darmową dostawę</b> pod wskazany adres.');
    let set = '';
    // Set discount: -5% from 3 pieces of furniture (keep in sync with snippets/am-perks and the automatic discount).
    const skip = acc && promo ? ' ' + T('cart_skip_acc_promo', 'Akcesoria i meble w promocji się nie liczą.') : acc ? ' ' + T('cart_skip_acc', 'Akcesoria się nie liczą.') : promo ? ' ' + T('cart_skip_promo', 'Meble w promocji się nie liczą.') : '';
    const without = acc && promo ? ' ' + T('cart_without_acc_promo', 'mebli; akcesoria i meble w promocji są bez rabatu.') : acc ? ' ' + T('cart_without_acc', 'mebli; akcesoria są bez rabatu.') : promo ? ' ' + T('cart_without_promo', 'mebli; meble w promocji są bez rabatu.') : '.';
    if (qty < 2 && qty + acc + promo > 0) set = T('cart_set_from3_html', 'Od 3 mebli w koszyku dostaniesz <b>−5%</b> za zestaw.') + skip;
    else if (qty === 2) set = T('cart_set_third_html', 'Dodaj trzeci mebel, a dostaniesz <b>−5%</b> za zestaw.') + skip;
    else if (qty > 2 && applied) set = T('cart_set_applied_html', 'Rabat za zestaw <b>−5%</b> jest już w cenie') + without;
    else if (qty > 2) set = T('cart_set_nocodes', 'Rabat za zestaw (−5% od 3 mebli) nie łączy się z kodami rabatowymi.');
    return (
      '<p class="am-perks__ship">' + ship + '</p>' +
      (MKT.cz ? '' : '<div class="am-perks__bar" role="progressbar" aria-label="' + T('cart_ship_progress', 'Postęp do darmowej dostawy') + '" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '"><i style="width:' + pct + '%"></i></div>') +
      '<p class="am-perks__set">' + set + '</p>'
    );
  }

  function getCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .catch(() => null);
  }

  async function paintPerks(cart) {
    const boxes = document.querySelectorAll('[data-am-perks]');
    if (!boxes.length) return;
    try {
      if (!cart) cart = await getCart();
      if (!cart) return;
      const sale = await saleIdsFor(cart);
      boxes.forEach((b) => {
        b.innerHTML = perksHtml(cart, sale);
        b.hidden = !cart.item_count;
      });
    } catch (e) {
      /* the server-rendered version stays */
    }
  }

  // Cart page: the theme re-renders the items after a quantity change and announces it here.
  document.addEventListener('DOMContentLoaded', function () {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => paintPerks());
    }
  });

  let el = null;

  function popup() {
    if (el) return el;
    el = document.createElement('div');
    el.className = 'am-pop';
    el.hidden = true;
    el.innerHTML =
      '<div class="am-pop__scrim" data-am-close></div>' +
      '<div class="am-pop__dialog" role="dialog" aria-modal="true" aria-label="' + T('cart_added', 'Dodano do koszyka') + '">' +
      '<button type="button" class="am-pop__x" data-am-close aria-label="' + T('common_close', 'Zamknij') + '">' +
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
      '<div class="am-pop__body"></div>' +
      '<div class="am-pop__foot">' +
      '<button type="button" class="am-pop__ghost" data-am-close>' + T('cart_continue', 'Kontynuuj zakupy') + '</button>' +
      '<a class="am-pop__cta" href="' + root + 'cart">' + T('cart_go_cart', 'Przejdź do koszyka') + '</a>' +
      '</div></div>';
    document.body.appendChild(el);
    return el;
  }

  // 13.10.2026 (audit A11Y-09): the element that opened the popup (the "Dodaj do koszyka" button) gets the focus back
  // when it closes, so a keyboard user carries on where they were instead of at the top of the page.
  let opener = null;
  function open() {
    const p = popup();
    const a = document.activeElement;
    if (p.hidden && a && a !== document.body && !p.contains(a)) opener = a;
    p.hidden = false;
    document.body.classList.add('am-pop-open');
    requestAnimationFrame(() => p.classList.add('is-on'));
    const close = p.querySelector('.am-pop__x');
    if (close) close.focus();
  }

  function close() {
    if (!el) return;
    el.classList.remove('is-on');
    document.body.classList.remove('am-pop-open');
    setTimeout(() => {
      if (el) el.hidden = true;
    }, 200);
    if (opener && opener.isConnected) opener.focus({ preventScroll: true });
    opener = null;
  }

  async function refreshBubble() {
    try {
      const res = await fetch(root + '?section_id=cart-icon-bubble');
      const html = await res.text();
      const node = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
      const bubble = document.getElementById('cart-icon-bubble');
      if (node && bubble) bubble.innerHTML = node.innerHTML;
    } catch (e) {
      /* the count is cosmetic */
    }
  }

  async function show(handle, info) {
    info = info || { pieces: 1, regular: 0, others: [] };
    const body = popup().querySelector('.am-pop__body');
    body.innerHTML = '<p class="am-pop__loading">' + T('cart_adding', 'Dodajemy do koszyka…') + '</p>';
    open();
    try {
      const [html, cart] = await Promise.all([
        fetch(root + 'products/' + handle + '?section_id=am-cart-popup').then((r) => r.text()),
        getCart(),
      ]);
      const node = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
      body.innerHTML = node ? node.innerHTML : '';
      // several pieces went in at once (quantity box or a whole set), so the header must not claim one
      if (info.pieces > 1) {
        const ok = body.querySelector('.am-pop__ok');
        const txt = ok && [...ok.childNodes].find((n) => n.nodeType === 3 && n.textContent.trim());
        if (txt) txt.textContent = ' ' + F(T('cart_added_n', 'Dodaliśmy {n} {word} do koszyka'), { n: info.pieces, word: mebel(info.pieces) });
      }
      paintAdded(body, info, cart);
      const head = body.querySelector('.am-pop__head');
      if (head) {
        const perks = document.createElement('div');
        perks.className = 'am-perks am-perks--pop';
        perks.setAttribute('data-am-perks', '');
        perks.hidden = true;
        head.appendChild(perks);
        paintPerks(cart);
      }
      body.querySelectorAll('.am-pop__panel').forEach(buildPanel);
    } catch (e) {
      body.innerHTML = '<p class="am-pop__loading">' + T('cart_in_cart_msg', 'Mebel jest w koszyku.') + '</p>';
    }
  }

  // ---- what was just added -----------------------------------------------------------------
  // A product form sends id + quantity; the "Pasuje do" set form sends items[n][id] (quantity 1 each).
  function requested(fd) {
    const qty = (v) => Math.max(1, parseInt(v, 10) || 1);
    const out = [];
    if (fd.has('id')) out.push({ id: Number(fd.get('id')), q: qty(fd.get('quantity')) });
    for (const [k, v] of fd.entries()) {
      const m = /^items\[(\d+)\]\[id\]$/.exec(k);
      if (m) out.push({ id: Number(v), q: qty(fd.get('items[' + m[1] + '][quantity]')) });
    }
    return out;
  }

  // Shop money format ({{amount_with_comma_separator}} zł) without ",00", like money_without_trailing_zeros.
  function pln(c) {
    const x = window.AMOR_MONEY ? window.AMOR_MONEY(c) : null;
    if (x != null) return x;
    c = Math.round(c);
    const z = String(Math.floor(c / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    const g = c % 100;
    return z + (g ? ',' + String(g).padStart(2, '0') : '') + ' zł';
  }

  // "Szafka RTV ROVERE 160 cm dąb z …" -> "Szafka RTV ROVERE 160 cm"
  function shortName(t) {
    const words = String(t || '').split(', ')[0].split(' ');
    const i = words.findIndex((w) => /^cm\b/.test(w));
    return (i > 0 ? words.slice(0, i + 1) : words.slice(0, 3)).join(' ');
  }

  function listPl(a) {
    return a.length < 2 ? a.join('') : a.slice(0, -1).join(', ') + ' ' + T('common_and', 'i') + ' ' + a[a.length - 1];
  }

  // The add.js response gives the line's NEW quantity, so pieces and money come from what the form sent.
  function addedInfo(req, lines, handle) {
    const byVariant = {};
    lines.forEach((l) => { byVariant[l.variant_id || l.id] = l; });
    let pieces = 0;
    let regular = 0;
    const others = [];
    req.forEach((r) => {
      const l = byVariant[r.id];
      pieces += r.q;
      if (!l) return;
      regular += (l.original_price != null ? l.original_price : l.price) * r.q;
      if (l.handle !== handle) others.push(shortName(l.product_title || l.title));
    });
    if (!pieces) pieces = lines.length || 1;
    return { pieces, regular, others, req };
  }

  // "Cena" row: one piece -> its price; several of one product -> total + "4 × 949 zł"; a set -> total of the
  // set and the other pieces named under the product. With a discount in the cart (the set discount from 3
  // pieces of furniture) the price after it comes first and the list price is struck through. Since 13.10.2026
  // the set discount reaches furniture lines only, so the price comes from the cart's own lines: final_line_price
  // (after line discounts) per piece, then order discounts shared in proportion (total_price / items_subtotal_price).
  function payAfter(info, cart) {
    if (!cart || !Array.isArray(cart.items) || !info.req || !info.req.length) return info.regular;
    const orderRatio = cart.items_subtotal_price > 0 ? Math.min(1, cart.total_price / cart.items_subtotal_price) : 1;
    let sum = 0;
    for (const r of info.req) {
      const l = cart.items.find((it) => Number(it.variant_id) === Number(r.id));
      if (!l || !l.quantity) return info.regular;
      sum += (l.final_line_price / l.quantity) * r.q;
    }
    return Math.min(info.regular, Math.round(sum * orderRatio));
  }
  function paintAdded(body, info, cart) {
    const dd = body.querySelector('.am-pop__price');
    if (!dd || !info.regular) return;
    const dt = dd.previousElementSibling;
    const set = info.others.length > 0;
    const pay = payAfter(info, cart);
    if (dt) dt.textContent = set ? F(T('cart_total_for', 'Razem za {n} {word}'), { n: info.pieces, word: mebel(info.pieces) }) : info.pieces > 1 ? T('zs_total', 'Razem') : T('cart_price', 'Cena');
    let html = pay < info.regular ? '<b>' + pln(pay) + '</b> <s>' + pln(info.regular) + '</s>' : pln(info.regular);
    if (!set && info.pieces > 1) html += '<small>' + info.pieces + ' × ' + pln(info.regular / info.pieces) + '</small>';
    dd.innerHTML = html;
    if (set) {
      const name = body.querySelector('.am-pop__name');
      if (name) {
        const p = document.createElement('p');
        p.className = 'am-pop__also';
        p.textContent = F(T('cart_also', 'W zestawie także: {list}.'), { list: listPl(info.others) });
        name.after(p);
      }
    }
  }

  // ---- cross-sell cards: size + colour pickers ----------------------------------------------
  const label = (it) => (it.k ? it.k + (it.c ? ' · ' + it.c : '') : it.c || T('cart_other_color', 'inny kolor'));
  const uniq = (arr) => [...new Set(arr)];

  function buildPanel(panel) {
    let items = [];
    try {
      items = JSON.parse(panel.dataset.items || '[]');
    } catch (e) {
      return;
    }
    if (!items.length) return;
    const kol = panel.dataset.kol || '';
    const mine = items.filter((i) => i.k === kol);
    const pool = mine.length ? mine : items;

    // One card per model (collection + colour). Two widths of the same model are the SAME card with
    // a width picker, never two cards - otherwise picking a width turns one card into the other.
    const picked = [];
    const seen = new Set();
    function take(list) {
      for (const i of list) {
        const k = label(i);
        if (seen.has(k)) continue;
        seen.add(k);
        picked.push(i);
        if (picked.length === 3) return;
      }
    }
    take(pool);
    if (picked.length < 3) take(items);
    const wrap = panel.querySelector('.am-pop__cards');
    wrap.innerHTML = '';
    picked.forEach((start) => wrap.appendChild(card(items, start)));
  }

  function card(items, start) {
    const li = document.createElement('div');
    li.className = 'am-pop__card';
    li.innerHTML =
      '<a class="am-pop__cph" href="#" tabindex="-1" aria-hidden="true"><img alt="" loading="lazy"></a>' +
      '<a class="am-pop__cnm" href="#"></a>' +
      '<div class="am-pop__sel"></div>' +
      '<div class="am-pop__buy"><b class="am-pop__cpr"></b>' +
      '<button type="button" class="am-pop__add">' + T('cart_add', 'Dodaj') + '</button></div>';

    let current = start;

    function selects() {
      const box = li.querySelector('.am-pop__sel');
      box.innerHTML = '';
      const sameColour = items.filter((i) => label(i) === label(current));
      const sizes = uniq(sameColour.map((i) => i.w)).sort((a, b) => a - b);
      const colours = uniq(items.filter((i) => i.w === current.w).map(label));

      if (sizes.length > 1) box.appendChild(picker(T('dims_width', 'Szerokość'), sizes.map((s) => [s + ' cm', s]), current.w, (v) => {
        const next = sameColour.find((i) => i.w === v);
        if (next) set(next);
      }));
      if (colours.length > 1) box.appendChild(picker(T('pd_color', 'Kolor'), colours.map((c) => [c, c]), label(current), (v) => {
        const next = items.find((i) => i.w === current.w && label(i) === v);
        if (next) set(next);
      }));
    }

    function set(it) {
      current = it;
      li.querySelector('.am-pop__cph').href = it.u;
      li.querySelector('.am-pop__cph img').src = it.im;
      const nm = li.querySelector('.am-pop__cnm');
      nm.href = it.u;
      nm.textContent = it.t;
      li.querySelector('.am-pop__cpr').textContent = it.p;
      li.querySelector('.am-pop__add').dataset.id = it.i;
      selects();
    }
    set(start);
    return li;
  }

  // Own dropdown instead of <select>: the native option list is drawn by the OS and cannot be styled.
  function closeDrops(except) {
    document.querySelectorAll('.am-pop__drop').forEach((d) => {
      if (d === except) return;
      d.querySelector('.am-pop__dlist').hidden = true;
      d.querySelector('.am-pop__dbtn').setAttribute('aria-expanded', 'false');
    });
  }

  function picker(name, options, value, onChange) {
    const wrap = document.createElement('div');
    wrap.className = 'am-pop__field';
    wrap.innerHTML =
      '<span class="am-pop__flab">' + name + '</span>' +
      '<div class="am-pop__drop">' +
      '<button type="button" class="am-pop__dbtn" aria-haspopup="listbox" aria-expanded="false">' +
      '<span class="am-pop__dval"></span>' +
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg></button>' +
      '<ul class="am-pop__dlist" role="listbox" hidden></ul></div>';

    const drop = wrap.querySelector('.am-pop__drop');
    const btn = wrap.querySelector('.am-pop__dbtn');
    const list = wrap.querySelector('.am-pop__dlist');
    let current = value;

    options.forEach(([text, val]) => {
      const li = document.createElement('li');
      li.className = 'am-pop__dopt';
      li.setAttribute('role', 'option');
      li.dataset.val = val;
      li.textContent = text;
      list.appendChild(li);
    });

    function paint() {
      const hit = options.find((o) => String(o[1]) === String(current));
      wrap.querySelector('.am-pop__dval').textContent = hit ? hit[0] : '';
      list.querySelectorAll('.am-pop__dopt').forEach((o) => {
        const on = String(o.dataset.val) === String(current);
        o.classList.toggle('is-on', on);
        o.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }

    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      const opening = list.hidden;
      closeDrops(drop);
      list.hidden = !opening;
      btn.setAttribute('aria-expanded', opening ? 'true' : 'false');
      if (opening) place();
    });

    // The popup body scrolls, so a list that would be clipped flips above the button, and if there
    // is no room either way the body scrolls just enough to show it.
    function place() {
      const scroller = drop.closest('.am-pop__body');
      list.classList.remove('is-up');
      if (!scroller) return;
      const box = list.getBoundingClientRect();
      const view = scroller.getBoundingClientRect();
      if (box.bottom <= view.bottom - 8) return;
      const over = btn.getBoundingClientRect().top - box.height - 8;
      if (over > view.top) list.classList.add('is-up');
      else scroller.scrollTop += box.bottom - view.bottom + 16;
    }

    list.addEventListener('click', function (e) {
      const opt = e.target.closest('.am-pop__dopt');
      if (!opt) return;
      current = opt.dataset.val;
      paint();
      list.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
      onChange(current);
    });

    paint();
    return wrap;
  }

  // ---- adding -------------------------------------------------------------------------------
  async function addVariant(id, btn) {
    if (btn) {
      btn.disabled = true;
      btn.classList.add('is-busy');
    }
    try {
      const res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }),
      });
      const state = await res.json();
      if (state.status) throw new Error(state.description || state.message);
      refreshBubble();
      paintPerks();
      if (btn) {
        btn.classList.remove('is-busy');
        btn.classList.add('is-done');
        btn.textContent = T('cart_in_cart_btn', 'W koszyku');
      }
    } catch (e) {
      console.error('[amor-cart]', e);
      if (btn) {
        btn.disabled = false;
        btn.classList.remove('is-busy');
      }
    }
  }

  // Capture phase: this runs before the theme's own product-form handler, so the drawer/notification
  // never takes over. Without JS the form posts normally and lands on /cart.
  document.addEventListener(
    'submit',
    async function (e) {
      const form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      const action = form.getAttribute('action') || '';
      if (!/\/cart\/add/.test(action)) return;

      e.preventDefault();
      e.stopPropagation();

      const btn = form.querySelector('[type="submit"]');
      if (btn) btn.setAttribute('aria-busy', 'true');

      const body = new FormData(form);
      const req = requested(body);
      let handle = form.dataset.amHandle || '';
      try {
        const res = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/javascript' },
          body,
        });
        const state = await res.json();
        if (state.status) throw new Error(state.description || state.message);
        const lines = state.items || [state];
        if (!handle) handle = (lines[0] && lines[0].handle) || '';
        refreshBubble();
        if (handle) {
          show(handle, addedInfo(req, lines, handle));
        } else {
          window.location = root + 'cart';
        }
      } catch (err) {
        console.error('[amor-cart]', err);
        form.submit();
      } finally {
        if (btn) btn.removeAttribute('aria-busy');
      }
    },
    true
  );

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.am-pop__drop')) closeDrops(null);
    if (e.target.closest('[data-am-close]')) {
      e.preventDefault();
      close();
      return;
    }
    const tab = e.target.closest('[data-am-tab]');
    if (tab) {
      const i = tab.dataset.amTab;
      const scope = tab.closest('.am-pop__cross');
      scope.querySelectorAll('[data-am-tab]').forEach((t) => {
        const on = t === tab;
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      scope.querySelectorAll('[data-am-panel]').forEach((p) => {
        p.hidden = p.dataset.amPanel !== i;
      });
      return;
    }
    const add = e.target.closest('.am-pop__add');
    if (add && add.dataset.id) addVariant(add.dataset.id, add);
  });

  // ---- product page: the price follows the quantity box (owner, 6.10.2026) --------------------
  // At 4 pieces 949,00 zł becomes 3.796,00 zł, with "4 × 949,00 zł" under it and, from 3 pieces, the price after
  // the automatic set discount (−5% from 3 pieces of furniture: keep in sync with the discount in Shopify and
  // snippets/am-perks). The unit price is read once from the price block itself (shop format "1.199,00 zł");
  // product-info.js re-renders that block on a variant change, so a MutationObserver re-applies the total.
  // The mobile sticky bar (snippets/am-pdp-sticky) shows the same total and adds the same quantity and variant.
  // Add-ons and the configurator (12.10.2026): assets/am-config.js puts its part on the price block as
  // box.amxPrice and fires "amx:price" on the block: {add: grosze per piece for the chosen add-ons, n and addSet
  // (below), base: grosze of the configured variant (configurator only, else 0), cmp: its compare-at price,
  // name: the words before the first amount of the line under the price, items: [[name, grosze], ...]}.
  // The price then shows (unit + add) × pieces and the line under it lists the parts. Set discount (13.10.2026):
  // furniture only, as in the cart. The product's own flag is .am-dlv[data-am-set] (snippets/am-pdp-delivery, "0"
  // for product type Akcesoria); add-ons count only when am-config marks them as furniture: x.n = how many such
  // add-ons per piece, x.addSet = their grosze per piece.
  const SET_MIN = 3;
  const SET_PCT = 5;
  // Shop format "1.199 zł" or "1.804,05 zł" -> grosze. 13.10.2026 (audit CON-06): prices show ",00" nowhere any more
  // (snippets/price uses money_without_trailing_zeros), so the grosze come only after a comma.
  // decimal separator of the visitor's currency (AMOR_MKT.fmt, snippets/am-i18n); złoty: ","
  const DEC = (MKT.cur && MKT.cur !== 'PLN' && MKT.fmt && MKT.fmt.d) || ',';
  const toCents = (txt) => {
    const m = String(txt || '').split(DEC).map((x) => x.replace(/\D/g, '')).join(',');
    if (!/\d/.test(m)) return 0;
    const [a, b = ''] = m.split(',');
    return parseInt(a || '0', 10) * 100 + parseInt((b + '00').slice(0, 2), 10);
  };
  // Like the product page price (money_without_trailing_zeros): grosze only when there are any.
  const money2 = (c) => pln(c);
  const escH = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  function initQtyPrice() {
    document.querySelectorAll('input.quantity__input[form^="product-form-"]').forEach((input) => {
      const sid = input.getAttribute('form').slice('product-form-'.length);
      const box = document.getElementById('price-' + sid);
      if (!box || box.dataset.amQty) return;
      box.dataset.amQty = '1';
      const sum = document.createElement('p');
      sum.className = 'am-qty-sum';
      sum.hidden = true;
      box.after(sum);
      const sticky = document.querySelector('[data-am-sticky]');

      // the first read keeps the server value, later paints reuse it (the text by then shows the total)
      const base = (n) => {
        if (!n) return 0;
        if (n.dataset.amBase === undefined) n.dataset.amBase = String(toCents(n.textContent));
        return Number(n.dataset.amBase) || 0;
      };

      function paint() {
        const field = document.getElementById(input.id) || input;
        let q = parseInt(field.value, 10);
        if (!(q > 0)) q = 1;
        const x = box.amxPrice || null;
        const add = (x && x.add) || 0;
        const pe = box.querySelector('.price');
        // the sale state from the server, kept so that a configured variant can switch it and give it back
        if (pe && pe.dataset.amSale === undefined) pe.dataset.amSale = pe.classList.contains('price--on-sale') ? '1' : '';
        const reg = box.querySelector('.price__regular .price-item--regular');
        const sale = box.querySelector('.price__sale .price-item--sale');
        const old = box.querySelector('.price__sale s.price-item--regular');
        let vals = [reg, sale, old].map(base);
        let onSale = pe ? pe.dataset.amSale === '1' : !!box.querySelector('.price--on-sale');
        if (x && x.base) {
          onSale = !!(x.cmp && x.cmp > x.base);
          vals = [x.base, x.base, onSale ? x.cmp : 0];
        }
        if (pe) pe.classList.toggle('price--on-sale', onSale);
        const unit = onSale ? vals[1] : vals[0];
        if (!unit) return;
        [reg, sale, old].forEach((n, i) => {
          if (n && vals[i]) n.textContent = money2((vals[i] + add) * q);
        });
        const total = (unit + add) * q;
        let html = '';
        const its = (x && x.items) || [];
        if (x && (x.name || its.length)) {
          const line = (x.name ? x.name + ' ' : '') + money2(unit) + its.map((a) => ' + ' + a[0] + ' ' + money2(a[1])).join('');
          html = '<span>' + escH(q > 1 ? q + ' × (' + line + ')' : line) + '</span>';
        } else if (q > 1) {
          html = '<span>' + q + ' × ' + money2(unit) + '</span>';
        }
        const dlv = document.querySelector('.am-dlv[data-am-set]');
        const mainSet = !dlv || dlv.dataset.amSet !== '0';
        if (q * ((mainSet ? 1 : 0) + ((x && x.n) || 0)) >= SET_MIN) {
          const setBase = q * ((mainSet ? unit : 0) + ((x && x.addSet) || 0));
          html += '<span>' + F(T('cart_qty_set_html', 'W koszyku z rabatem za zestaw (−{pct}%): <b>{amount}</b>'), { pct: SET_PCT, amount: money2(total - Math.round((setBase * SET_PCT) / 100)) }) + '</span>';
        }
        sum.innerHTML = html;
        sum.hidden = !html;
        // "Zestaw taniej … ten mebel" (snippets/am-pdp-delivery): one piece after the set discount, for the variant
        // shown, also another size picked in the configurator (rounded like Shopify: half up to the grosz)
        const setP = document.querySelector('.am-dlv__set-p b');
        if (setP) setP.textContent = money2(unit - Math.round((unit * SET_PCT) / 100));
        if (sticky) {
          const sp = sticky.querySelector('b');
          if (sp) sp.textContent = pln(total);
          const f = sticky.querySelector('form');
          // the sticky form adds the variant chosen on the page, not the one the page was opened with
          const mid = document.querySelector('#product-form-' + sid + ' input[name="id"]');
          const fid = f && f.querySelector('input[name="id"]');
          if (mid && fid && mid.value && fid.value !== mid.value) fid.value = mid.value;
          if (f) {
            let sq = f.querySelector('input[name="quantity"]');
            if (!sq) {
              sq = document.createElement('input');
              sq.type = 'hidden';
              sq.name = 'quantity';
              f.appendChild(sq);
            }
            sq.value = q;
          }
        }
      }

      const mine = (e) => e.target && e.target.id === input.id;
      document.addEventListener('change', (e) => { if (mine(e)) paint(); });
      document.addEventListener('input', (e) => { if (mine(e)) paint(); });
      new MutationObserver(paint).observe(box, { childList: true });
      box.addEventListener('amx:price', paint);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.quantityUpdate, paint);
      }
      paint();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initQtyPrice);
  else initQtyPrice();

  // ---- cart page: "Usuń wszystko" (inline confirmation, no browser dialog) --------------------
  document.addEventListener('click', async function (e) {
    const ask = e.target.closest('[data-am-clear-ask]');
    const no = e.target.closest('[data-am-clear-no]');
    const yes = e.target.closest('[data-am-clear-yes]');
    if (!ask && !no && !yes) return;
    const box = e.target.closest('[data-am-clear]');
    if (!box) return;
    const askBtn = box.querySelector('[data-am-clear-ask]');
    const confirmBox = box.querySelector('[data-am-clear-confirm]');
    if (ask) {
      askBtn.hidden = true;
      confirmBox.hidden = false;
      const y = confirmBox.querySelector('[data-am-clear-yes]');
      if (y) y.focus();
      return;
    }
    if (no) {
      confirmBox.hidden = true;
      askBtn.hidden = false;
      askBtn.focus();
      return;
    }
    yes.disabled = true;
    yes.textContent = T('cart_removing', 'Usuwamy…');
    try {
      await fetch(root + 'cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } });
    } catch (err) {
      console.error('[amor-cart]', err);
    }
    window.location.reload();
  });

  document.addEventListener('keyup', function (e) {
    if (e.key !== 'Escape' || !el || el.hidden) return;
    const open_drop = el.querySelector('.am-pop__dlist:not([hidden])');
    if (open_drop) {
      closeDrops(null);
      return;
    }
    close();
  });
})();